import React from 'react';

const LandingFooter = () => {
    return (
        <div className="landing-footer">
            <div className="container">
                <div className="row menu-foot">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-4">
                                <h3>Blogs</h3>
                                <a href="#!">Our Vison & Our Goal</a>
                                <a href="#!">Solutions for real Problems</a>
                            </div>
                            <div className="col-md-4">
                                <h3></h3>
                                <a href="#!">Our Products</a>
                                <a href="#!">How does it work</a>
                            </div>
                            <div className="col-md-4">
                                <h3></h3>
                                <a href="#!">Our team</a>
                                <a href="#!">Why us</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h3>Contacts</h3>
                        <div className="row">
                            <div className="col-md-4">
                                <a href="#!"> tech@cradel-vision.com</a>
                                <a href="#!"> +998 95 252 66 00</a>
                            </div>
                            <div className="col-md-8">
                                <a href="#!"> 131А Parkent Street, Tashkent 111301,
                                    Uzbekistan</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingFooter;
